<template>
  <ten-input-formatted
    v-bind="$attrs"
    v-on="listeners"
    class="ten-input-number"
    :value="value"
    :type="formatter ? 'text' : 'number'"
    :parser="inputNumberParser"
    :formatter="inputNumberFormatter"
    @keydown="onKeyDown"
    @change="onChange"
  >
    <template v-slot:inputSuffix>
      <div class="ten-input-number__action">
        <span
          role="button"
          :tabindex="0"
          :class="['ten-input-number__action-up', {
            'ten-input-number__action--disabled': upDisabled
          }]"
          @click.stop="stepChange(1)"
          @keydown.enter="stepChange(1)"
        />
        <span
          role="button"
          :tabindex="0"
          :class="['ten-input-number__action-down', {
            'ten-input-number__action--disabled': downDisabled
          }]"
          @click.stop="stepChange(-1)"
          @keydown.enter="stepChange(-1)"
        />
      </div>
    </template>
  </ten-input-formatted>
</template>

<script>
import valueFormat from '../input/value-format';
import NP from 'number-precision';

const name = 'ten-input-number';

function getValidNum(val = '', trigger = 'input') {
  let value = String(val);

  /* eslint-disable */
  value = value
    .replace(/^-/, '*').replace('-', '').replace('*', '-')
    .replace(/[^-\d\.]/g, '').replace(/\d*\.(?=\d*\.)/g, function (dotStr) {
    return dotStr.replace('.', '');
  });
  /* eslint-enable */

  if (trigger === 'input') {
    return value;
  }
  if (value !== '' && !isNaN(Number(value))) {
    value = Number(value);
  }

  return value === '' ? undefined : value;
}

function emptyHandler(value) {
  return value == null ? '' : value; // eslint-disable-line
}

const TenInputFormatted = valueFormat();

export default {
  name,
  components: {
    TenInputFormatted,
  },
  inheritAttrs: false,
  props: {
    /**
     * 值
     * @model
     */
    value: Number,
    /**
     * 格式化value值，配合formatter使用
     */
    parser: Function,
    /**
     * 格式化value值，配合parser使用
     */
    formatter: Function,
    /**
     * 最大值
     */
    max: Number,
    /**
     * 最小值
     */
    min: Number,
    /**
     * 步长
     */
    step: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    inputNumberParser() {
      return [
        {
          handler: this.parser,
          input: true,
        },
        {
          handler: v => getValidNum(v, 'input'),
          input: true,
        },
        {
          handler: v => getValidNum(v, 'change'),
        },
        this.checkRange,
      ];
    },
    inputNumberFormatter() {
      return this.formatter ? [
        emptyHandler,
        {
          handler: this.formatter,
          input: true,
        },
      ] : [];
    },
    upDisabled() {
      return this.max <= this.value;
    },
    downDisabled() {
      return this.min >= this.value && typeof this.value !== 'undefined';
    },
    listeners() {
      const { keydown, change, ...others } = this.$listeners;
      return others;
    },
  },
  methods: {
    checkRange(value) {
      const { max, min } = this;

      if (value < min) return min;
      if (value > max) return max;

      return value;
    },
    onKeyDown(e) {
      if (this.$attrs.disabled) return;
      // 禁用 e
      if (e.code === 'keyE' || e.keyCode === 69) {
        e.preventDefault();
        return;
      }
      if (e.keyCode === 38 || e.keyCode === 40) {
        e.keyCode === 38 ? this.stepChange(1) : this.stepChange(-1);
        e.preventDefault();
      }
      this.$emit('keydown', e);
    },
    stepChange(neg = 1) {
      if (this.$attrs.disabled) return;

      let { value } = this;

      value = isNaN(value) || value === null ? 0 : value;
      value = NP.plus(value, this.step * neg);

      value = this.checkRange(value);

      this.onChange(value);
    },
    onChange(value) {
      /**
       * change事件
       * @param {Number} value 数值
       */
      this.$emit('change', value);
    },
  },
};
</script>
